
define('template!companiesDetailHeaderView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="logo default-upload-image"></div>\n<div class="infos">\n  <div class="name-ctn">\n    <div class="name">' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'</div>\n    <input type="text" class="name-input" autocomplete="off" maxlength="255" style="display: none;" value="' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'" />\n    <span class="edit-name" title="' +
((__t = ( _.i18n('common.edit', null, 'Edit') )) == null ? '' : __t) +
'">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/></svg>\n    </span>\n  </div>\n  <div class="domain">' +
((__t = ( emailDomain )) == null ? '' : __t) +
'</div>\n  <div class="vat">';
 if (vatNumber) { ;
__p +=
((__t = ( _.i18n('common.vatNumber') || 'VAT' )) == null ? '' : __t) +
': ' +
((__t = ( vatNumber )) == null ? '' : __t);
 } ;
__p += '</div>\n</div>\n<div class="tools">\n  <div class="ctn-1">\n    <span class="comment-button item';
 if (comment) { ;
__p += ' has-comment';
 } ;
__p += '" title="' +
((__t = ( _.i18n('companies.comment', null, 'Comment') )) == null ? '' : __t) +
'">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"/></svg>\n    </span>\n  </div>\n  <div class="ctn-2">\n    <div class="back-region"></div>\n  </div>\n</div>\n';

}
return __p
};});

